<template>
    <div>
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="vertical-flow">
            <div class="listing-header columns">
                <div class="group-search column">
                    <search-bar :onSearch="debouncedOnSearch" />
                </div>

                <div class="header-buttons column mr-3 is-2">
                    <button
                        v-if="permissao.update"
                        @click="save()"
                        :disabled="isSaving"
                        class="save-btn is-100 mt-3"
                        type="button"
                    >
                        {{ $t('salvar') }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                </div>
            </div>

            <div class="checkbox-group column">
                <div v-if="logisticaSelecionado.length > 0" class="is-flex-column">
                    <span class="subtitle">{{ $t('selecionados') }}:</span>
                    <div class="columns is-flex-wrap">
                        <div
                            v-for="(logistica, key) in logisticaSelecionado"
                            :key="key"
                            class="column is-3 is-flex is-flex-vcenter"
                        >
                            <b-checkbox v-model="logisticaSelecionado" :native-value="logistica">
                                {{ logistica.descricao }}
                            </b-checkbox>
                        </div>
                    </div>
                </div>
                <hr />
                <div class="is-flex-column">
                    <div class="is-flex is-flex-vcenter">
                        <span class="subtitle m-0">{{ $t('opcoes') }}:</span>
                        <b-icon
                            icon="information"
                            size="is-small"
                            v-tippy
                            :title="$t('aviso-logistica')"
                        />
                    </div>

                    <empty-table-message v-if="isEmpty" />
                    <div class="columns is-flex-wrap">
                        <div
                            v-for="(logistica, key) in logisticas"
                            :key="key"
                            class="column is-3 is-flex-vcenter"
                        >
                            <b-checkbox v-model="logisticaSelecionado" :native-value="logistica">
                                {{ logistica.descricao }}
                            </b-checkbox>
                        </div>
                    </div>
                </div>
            </div>

            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import B2BLogisticaService from '@/services/b2b/B2BLogisticaService';
import B2BClienteLogisticaService from '@/services/b2b/B2BClienteLogisticaService';

export default {
    components: {
        ContainerLoader,
    },
    data() {
        return {
            permissao: {},
            isLoading: false,
            isSaving: false,
            logisticas: [],
            logisticaSelecionado: [],
            debouncedOnSearch: null,
            b2bLogisticaService: new B2BLogisticaService(this.$http, this.$router),
            service: new B2BClienteLogisticaService(this.$http, this.$router),
            isEmpty: false,
            searchQuery: '',
            pagination: {
                resetPagination: false,
                perPageOptions: [20, 60, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess('b2b', 'b2b-parametrizacoes-edit');

        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'dados-iniciais' },
            });
        } else {
            this.carregarDados().then((_) => {
                this.carregarClienteLogistica();
            });
        }

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
    },
    methods: {
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSearch(value) {
            this.pagination.currentPage = 1;
            this.searchQuery = value;
            this.carregarDados();
        },
        carregarDados(currentPage = 1) {
            return new Promise((resolve) => {
                this.isLoading = true;

                if (currentPage == 1 && this.pagination.currentPage != 1)
                    this.pagination.resetPagination = true;

                this.b2bLogisticaService
                    .findAll(currentPage - 1, this.pagination.perPage, this.searchQuery)
                    .then(({ content, totalElements }) => {
                        this.logisticas = content;
                        this.pagination.totalRows = totalElements;
                        this.isEmpty = content.length <= 0;
                    })
                    .catch((e) => {
                        this.isEmpty = true;
                        this.$root.showMessage('error', 'msg-erro-load-logistica');
                    })
                    .finally((_) => {
                        this.pagination.resetPagination = false;
                        this.isLoading = false;
                        resolve();
                    });
            });
        },
        carregarClienteLogistica() {
            this.service
                .findAll()
                .then(({ content }) => {
                    this.logisticaSelecionado = content.map(({ id, ...rest }) => rest);
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-dados-geral');
                });
        },
        save() {
            this.service
                .insertBulk(this.logisticaSelecionado)
                .then((_) => {
                    this.$root.showMessage('success', 'msg-save-logistica-sucesso');
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-dados-geral');
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.checkbox-group {
    padding: 0.5em 0.75em;
}

.group-search {
    .search-wrapper {
        border-radius: 5px;
    }
}
.checkbox {
    font-size: 14px;
    padding: 8px 0;
}

.subtitle {
    color: var(--primary-color);
}
</style>
